const Ge = {
  init: function(n) {
    (void 0 === n && void 0 !== Ge.zg) || (Ge.zg = !!n), Ge.Eg || (Ge.Eg = !0);
  },
  destroy: function() {
    (Ge.Eg = !1), (Ge.zg = void 0), (Ge.nd = void 0);
  },
  setLogger: function(n) {
    "function" == typeof n
      ? (Ge.init(), (Ge.nd = n))
      : Ge.info("Ignoring setLogger call since logger is not a function");
  },
  toggleLogging: function() {
    Ge.init(),
      Ge.zg
        ? (console.log("Disabling Braze logging"), (Ge.zg = !1))
        : (console.log("Enabled Braze logging"), (Ge.zg = !0));
  },
  info: function(n) {
    if (Ge.zg) {
      const o = "Braze: " + n;
      null != Ge.nd ? Ge.nd(o) : console.log(o);
    }
  },
  warn: function(n) {
    if (Ge.zg) {
      const o = "Braze SDK Warning: " + n + " (v4.7.0)";
      null != Ge.nd ? Ge.nd(o) : console.warn(o);
    }
  },
  error: function(n) {
    if (Ge.zg) {
      const o = "Braze SDK Error: " + n + " (v4.7.0)";
      null != Ge.nd ? Ge.nd(o) : console.error(o);
    }
  }
};
export default Ge;
